export default {
  site: {
    name: 'Exam Portal',
    welcome: 'Welcome to Exam Portal',
  },
  nav: {
    home: 'Home',
    news: 'News',
    exam: 'Exam Updates',
    policy: 'Policy',
    resource: 'Resources',
    category: 'Categories',
    search: 'Search',
    feedback: 'Feedback',
    menu: 'Menu',
  },
  article: {
    title: 'Title',
    content: 'Content',
    publishedAt: 'Published',
    source: 'Source',
    views: 'Views',
    related: 'Related Articles',
    featured: 'Featured',
    latest: 'Latest News',
    noArticles: 'No articles found',
  },
  category: {
    gaokao: 'Gaokao',
    zhongkao: 'Zhongkao',
    kaoyan: 'Postgrad Exam',
    gongwuyuan: 'Civil Service',
    zhiye: 'Professional Cert',
    yingyu: 'English Exam',
    liuxue: 'Study Abroad',
  },
  search: {
    title: 'Search',
    placeholder: 'Enter keywords to search...',
    resultCount: '{count} results found',
    noResult: 'No results found',
  },
  feedback: {
    name: 'Name',
    email: 'Email',
    content: 'Feedback',
    submit: 'Submit',
    success: 'Submitted successfully. Thank you for your feedback!',
    fail: 'Submission failed. Please try again later.',
    namePlaceholder: 'Enter your name',
    emailPlaceholder: 'Enter your email',
    contentPlaceholder: 'Enter your feedback',
    description: 'If you have any suggestions or questions, please let us know through the form below.',
  },
  common: {
    loading: 'Loading...',
    loadMore: 'Load More',
    backHome: 'Back to Home',
    copyright: 'All Rights Reserved',
    notFound: 'Page Not Found',
  },
}
